export default __webpack_public_path__ + "static/media/fr-asia-9.1a4ae667.jpg";